import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAttendanceByDate,
  fetchStaffAttendanceStats,
  fetchStaffsMonthAttendanceList,
  markStaffAttendance,
  fetchStaffAttendanceYearlyStats, // ✅ import the new thunk
} from "./staffAttendance.thunk";
const now = new Date();
const initialState = {
  attendanceData: [],
  stats: {},
  monthlyAttendance: [],
  yearlyStats: {}, // ✅ added yearly stats
  filters: {
    month: now.getMonth() + 1,
    year: now.getFullYear(),
    filter: "",
    role: "",
  },
  selectedDate: new Date(),
  loading: false,
  markingAttendance: false,
  error: null,
};

const staffAttendanceSlice = createSlice({
  name: "staffAttendance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },

    resetFilters: (state) => {
      state.filters = {
        month: now.getMonth() + 1,
        year: now.getFullYear(),
        filter: "",
        role: "",
      };
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    updateStaffAttendanceStatus: (state, action) => {
      const { StaffId, status } = action.payload;
      const StaffIndex = state.attendanceData.findIndex(
        (staff) => staff.StaffId == StaffId
      );
      if (StaffIndex !== -1) {
        if (!Array.isArray(state.attendanceData[StaffIndex].attendanceStatus)) {
          state.attendanceData[StaffIndex].attendanceStatus = [];
        }
        state.attendanceData[StaffIndex].attendanceStatus = status;
      }
    },
    markAllStaffAttendance: (state, action) => {
      const { status } = action.payload;
      if (state.attendanceData?.length > 0) {
        state.attendanceData = state.attendanceData.map((staff) => ({
          ...staff,
          attendanceStatus: status,
        }));
      }
    },
    clearAttendanceState: (state) => {
      state.attendanceData = [];
      state.error = null;
      state.stats = {};
      state.yearlyStats = {}; // ✅ clear yearly stats also
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch attendance by date
      .addCase(fetchAttendanceByDate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendanceByDate.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceData = action.payload?.attendanceList || [];
        state.stats = {
          totalStaffs: action?.payload?.summaries?.totalStaffs || 0,
          presentCount: action?.payload?.summaries?.totalPresent || 0,
          absentCount: action?.payload?.summaries?.totalAbsent || 0,
          leaveCount: action?.payload?.summaries?.totalLeave || 0,
        };
      })
      .addCase(fetchAttendanceByDate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Mark attendance
      .addCase(markStaffAttendance.pending, (state) => {
        state.markingAttendance = true;
        state.error = null;
      })
      .addCase(markStaffAttendance.fulfilled, (state) => {
        state.markingAttendance = false;
      })
      .addCase(markStaffAttendance.rejected, (state, action) => {
        state.markingAttendance = false;
        state.error = action.payload;
      })

      // Fetch attendance stats
      .addCase(fetchStaffAttendanceStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffAttendanceStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchStaffAttendanceStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Staffs' monthly attendance list
      .addCase(fetchStaffsMonthAttendanceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffsMonthAttendanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyAttendance = action.payload?.attendanceList || [];
      })
      .addCase(fetchStaffsMonthAttendanceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchStaffAttendanceYearlyStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffAttendanceYearlyStats.fulfilled, (state, action) => {
        state.loading = false;
        state.yearlyStats = action.payload || {};
      })
      .addCase(fetchStaffAttendanceYearlyStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setFilters,
  resetFilters,
  setSelectedDate,
  updateStaffAttendanceStatus,
  clearAttendanceState,
  markAllStaffAttendance
} = staffAttendanceSlice.actions;

export default staffAttendanceSlice.reducer;
